import { render } from "./V1ProviderGroupView.vue?vue&type=template&id=3872b3da&scoped=true&ts=true"
import script from "./V1ProviderGroupView.vue?vue&type=script&lang=ts"
export * from "./V1ProviderGroupView.vue?vue&type=script&lang=ts"

import "./V1ProviderGroupView.vue?vue&type=style&index=0&id=3872b3da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3872b3da"]])

export default __exports__